module.exports = __webpack_public_path__ + "img/tool_zoom_out.64e0b004.png";